import type { FC, MouseEvent } from 'react';
import { useCallback, useEffect, useState } from 'react';
import type { ButtonProps } from '@mui/material/Button';
import Button from '@mui/material/Button';

interface LoadingPromiseButtonProps extends Omit<ButtonProps, 'loading'> {
  promise: Promise<unknown> | undefined;
}

export const LoadingPromiseButton: FC<LoadingPromiseButtonProps> = ({
  promise,
  ...props
}) => {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!promise) {
      return;
    }
    (async function () {
      setLoading(true);
      await promise;
      setLoading(false);
    })();
  }, [promise]);
  return <Button loading={loading} {...props} />;
};

export const LoadingPromiseButtonAdvanced: FC<Omit<ButtonProps, 'loading'>> = ({
  onClick: onClickOriginal,
  ...props
}) => {
  const [loading, setLoading] = useState(false);

  const onClick = useCallback(
    async (e: MouseEvent<HTMLButtonElement>) => {
      try {
        setLoading(true);
        await onClickOriginal?.(e);
      } finally {
        setLoading(false);
      }
    },
    [onClickOriginal]
  );

  return <Button loading={loading} {...props} onClick={onClick} />;
};
